module.exports = __webpack_public_path__ + "img/PLATINUM - sales, trainer, implementation, migration.b3d2ac89.png";